/**
 * PageHeader - generic page title/header block.
 * Custom element: <page-header>
 *
 * Loading: lazy-loaded by the theme loader (theme.js), which imports this
 * file by its exact name - the filename is load-bearing (import map in
 * snippets/theme-head.liquid).
 * Reconstructed to readable identifiers from the original minified vendor
 * bundle; behaviour verified unchanged by AST alpha-equivalence.
 */
var defineProperty = Object.defineProperty;
var setFunctionName = (target, functionName) => defineProperty(target, "name", {
  value: functionName,
  configurable: !0
});
import { ThemeComponent } from "./theme.js";
import "./vendor.js";
class PageHeader extends ThemeComponent {}
setFunctionName(PageHeader, "PageHeader");
const propertyTypes = {};
PageHeader.prototype.$name = "PageHeader";
PageHeader.prototype.$info = JSON.parse('{"name":"PageHeader","meta":{"isLegacy":false,"selector":"page-header"},"props":[],"refs":[]}');
PageHeader.prototype.$info.component = PageHeader;
for (const prop of PageHeader.prototype.$info.props) prop.propertyType = propertyTypes[prop.propertyType];
window.componentService.registerComponent("PageHeader/PageHeader.ts", {
  PageHeader: PageHeader
}, void 0);